<template>
  <!-- Registration Types sidebar start -->
  <div
    class="modal right fade ss-reg-type-sidebar-modal"
    id="RegistrationtypeModal"
    tabindex=""
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="reg-type-wrapper">
            <div class="reg-type-head">
              <h3>
                {{
                  showRegTypeFormPopUp
                    ? "Save Registration Type"
                    : "Registration Types"
                }}
              </h3>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              class="create-new-reg-button mt-4"
              v-if="!showRegTypeFormPopUp"
            >
              <button @click="addRegistrationType()">
                <span
                  ><img src="../assets/Images/reg-ico/create-new-reg-type.svg"
                /></span>
                Create New
              </button>
            </div>
            <div class="reg-type-table mt-5 px-5" v-if="!showRegTypeFormPopUp">
              <div class="row">
                <div class="col-md-3">
                  Registration Type
                  <span
                    ><img src="../assets/Images/reg-ico/table-filter.svg"
                  /></span>
                </div>
                <div class="col-md-1 d-none">
                  Price
                  <span
                    ><img src="../assets/Images/reg-ico/table-filter.svg"
                  /></span>
                </div>
                <div class="col-md-2 text-center">
                  Max Quantity
                  <span
                    ><img src="../assets/Images/reg-ico/table-filter.svg"
                  /></span>
                </div>
                <div
                  class="
                    col-md-1
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  Min Limit
                  <!-- <span
                    ><img src="../assets/Images/reg-ico/table-filter.svg"
                  /></span> -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#333" size="22px" v-bind="attrs" v-on="on"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span
                      >Set the minimum number of tickets<br />that can be
                      purchased in one order.</span
                    >
                  </v-tooltip>
                </div>
                <div
                  class="
                    col-md-1
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  Max Limit
                  <!-- <span
                    ><img src="../assets/Images/reg-ico/table-filter.svg"
                  /></span> -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#333" size="22px" v-bind="attrs" v-on="on"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span
                      >Set the maximum number of tickets<br />
                      that can be purchased in one order.</span
                    >
                  </v-tooltip>
                </div>
                <div class="col-md-1">Status</div>
                <div class="col-md-2">Visibility</div>
                <div class="col-md-1">Action</div>
              </div>
              <div
                class="row"
                v-for="(ticket, index) in RegistrationTypeList"
                :key="index"
              >
                <div class="col-md-3">{{ ticket.RegistrationType }}</div>
                <div class="col-md-1 text-left d-none">
                  {{ ticket.FormType }}
                </div>
                <div class="col-md-2 text-center">{{ ticket.Quantity }}</div>
                <div class="col-md-1 text-left">{{ ticket.MinLimit }}</div>
                <div class="col-md-1 text-left">{{ ticket.MinLimit }}</div>
                <div class="col-md-1">
                  <!-- <v-chip outlined color="green" v-if="ticket.IsPublished"
                    >Open</v-chip
                  >
                  <v-chip outlined color="orange" v-else>Closed</v-chip> -->
                  <v-switch
                    v-model="RegistrationTypeList[index].IsPublished"
                    @change="
                      changeRegTypesStatus(
                        ticket.IsPublished,
                        ticket.RegistrationTypeId
                      )
                    "
                  ></v-switch>
                </div>
                <div class="col-md-2">
                  <v-chip outlined color="green" v-if="ticket.Visibility"
                    >Visible</v-chip
                  >
                  <v-chip outlined color="orange" v-else>Hidden</v-chip>
                </div>
                <div class="col-md-1">
                  <ul class="action-switch">
                    <li class="mr-4">
                      <a
                        href="#"
                        @click="
                          editRegistrationType(`${ticket.RegistrationTypeId}`)
                        "
                        ><img src="../assets/Images/reg-ico/edit.svg"
                      /></a>
                    </li>
                    <!-- <li>
                        <a href="#"
                          ><img src="../assets/Images/reg-ico/delete.svg"
                        /></a>
                      </li> -->
                  </ul>
                </div>
              </div>
            </div>
            <div class="add-reg-type-form my-0" v-if="showRegTypeFormPopUp">
              <div class="switch-field-page-tab" style="visibility: hidden">
                <input
                  type="radio"
                  id="radio-one"
                  name="FormType"
                  value="Paid"
                  v-model="regTypeFormData.FormType"
                />
                <label for="radio-one">Paid</label>
                <input
                  type="radio"
                  id="radio-two"
                  name="FormType"
                  value="Free"
                  v-model="regTypeFormData.FormType"
                />
                <label for="radio-two">Free</label>
              </div>
              <div class="add-reg-form-inner">
                <label>Type Name<span>*</span></label>
                <input
                  type="text"
                  v-model="regTypeFormData.RegistrationType"
                  placeholder="Add registration type name"
                />
                <v-row>
                  <v-col cols="6" sm="6" md="6" class="mb-3">
                    <label>Quantity* <span></span></label>
                    <v-text-field
                      type="number"
                      v-model="regTypeFormData.Quantity"
                      placeholder="Add Quantity"
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6" class="color-choose-sec mb-3">
                    <label>Colour* <span></span></label>
                    <v-text-field v-model="regTypeFormData.ColorCode">
                      <template v-slot:append>
                        <v-menu
                          v-model="ColourPicker"
                          nudge-left="16"
                          :close-on-content-click="false"
                        >
                          <template v-slot:activator="{ on }">
                            <div :style="swatchStyle" v-on="on" />
                          </template>
                          <v-card>
                            <v-card-text>
                              <v-color-picker
                                v-model="regTypeFormData.ColorCode"
                                flat
                              />
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="regTypeFormData.FormType == 'Paid'">
                  <v-col cols="6" sm="6" md="6" class="amount-wrap mb-3">
                    <label>Price</label>
                    <v-text-field
                      type="number"
                      v-model="regTypeFormData.Price"
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6" class="currency-wrap mb-3">
                    <div
                      class="d-flex align-items-end justify-content-start"
                      style="height: 100%"
                    >
                      <v-select
                        :items="Currencies"
                        label="Currency"
                        item-text="cc"
                        v-model="regTypeFormData.Currency"
                        single-line
                        return-object
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
                <label>Short Description(optional)</label>
                <textarea
                  cols="5"
                  rows="8"
                  v-model="regTypeFormData.Description"
                ></textarea>

                <div class="adv-settings-option my-3">
                  <v-switch
                    color="#1a73e8"
                    v-model="regTypeFormData.AdvancedSettings"
                  />
                  <p>Advanced Settings</p>
                </div>
                <div
                  class="sales-drop-wrap mt-3"
                  v-if="regTypeFormData.AdvancedSettings"
                >
                  <!-- <div class="row my-0">
                      <div class="col-md-6">
                        <div>
                          <label>Sales Start</label>
                          <select>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div>
                          <label>Sales End</label>
                          <select>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                            <option>On Specific date &amp; time</option>
                          </select>
                        </div>
                      </div>
                    </div> -->
                </div>
                <div
                  class="regdate mt-4"
                  v-if="regTypeFormData.AdvancedSettings"
                >
                  <div class="row my-0">
                    <div class="col-md-6">
                      <div class="reg-date position-relative">
                        <span>Sale Start</span>
                        <flat-pickr
                          name="SaleStartDate"
                          v-model="regTypeFormData.SaleStartDate"
                          :config="configdateTimePickerStart"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="reg-date position-relative">
                        <span>Sale End</span>
                        <flat-pickr
                          name="SaleEndDate"
                          v-model="regTypeFormData.SaleEndDate"
                          :config="configdateTimePickerEnd"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="regTypeFormData.AdvancedSettings" />
                <div
                  class="ticket-status-visibility"
                  v-if="regTypeFormData.AdvancedSettings"
                >
                  <v-row class="my-0">
                    <v-col md="6">
                      <label>Ticket Status</label>
                      <div
                        class="switch-field-page-tab mb-0"
                        style="overflow: inherit"
                      >
                        <v-switch
                          color="#1a73e8"
                          v-model="regTypeFormData.IsPublished"
                        />
                      </div>
                    </v-col>
                    <v-col md="6">
                      <label>Ticket Visibility</label>
                      <div
                        class="switch-field-page-tab mb-0"
                        style="overflow: inherit"
                      >
                        <v-switch
                          color="#1a73e8"
                          v-model="regTypeFormData.Visibility"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <hr v-if="regTypeFormData.AdvancedSettings" />
                <div
                  class="order-tickets"
                  v-if="regTypeFormData.AdvancedSettings"
                >
                  <label>Tickets Per Order</label>
                  <div class="row">
                    <div class="col-md-6 mt-2">
                      <label>Minimum</label>
                      <input type="number" v-model="regTypeFormData.MinLimit" />
                    </div>
                    <div class="col-md-6 mt-2">
                      <label>Maximum</label>
                      <input type="number" v-model="regTypeFormData.MaxLimit" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="submit-form-switch">
                <v-btn
                  outlined
                  color="#1c1d26"
                  class="cancel-form cancel-standard"
                  @click="showRegTypeFormPopUp = false"
                  width="100px"
                >
                  Cancel
                </v-btn>
                <v-btn
                  dark
                  color="#2376e5"
                  class="save-form save-standard"
                  @click="saveRegistrationType()"
                  width="100px"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Registration Types sidebar end -->
</template>
<script>
import APIs from "@/components/APIInit";
import store from "../store";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
var self;
import Vue from "vue";
import axios from "axios";
import { bus } from "@/main";

Vue.use(VueMoment, {
  moment,
});

export default {
  data() {
    return {
      event_timezone: store.getters.getZone,
      eventid: null,
      clientID: null,
      event_collectionName: null,
      userID: null,
      blankRules: [(v) => !!v || "This field is required"],
      RegistrationTypeList: [],
      showRegTypeFormPopUp: false,
      regTypeFormData: {
        RegistrationTypeId: null,
        RegistrationType: null,
        ColorCode: "#000",
        FormType: "Free",
        Currency: null,
        Price: 0.0,
        PriceIncludingTax: true,
        Tax: 0,
        Quantity: 999,
        Expiry: 2,
        MinLimit: 1,
        MaxLimit: 1,
        Description: null,
        SaleStartDate: new Date(),
        SaleEndDate: new Date(),
        IsPublished: true,
        Visibility: true,
        AdvancedSettings: false,
      },
      Currencies: [],
      configdateTimePickerStart: {
        minDate: new Date(),
        maxDate: null,
        onChange: function (val) {
          if (val) self.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
        position: "above",
      },
      configdateTimePickerEnd: {
        minDate: new Date(),
        maxDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
        position: "above",
      },
      ColourPicker: false,
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    swatchStyle() {
      const { ColourPicker } = this;
      return {
        backgroundColor: this.regTypeFormData.ColorCode,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: ColourPicker ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
  watch: {},
  async created() {
    //alert("created")
    self = this;
    self.clientID = self.getClientId();
    self.eventid = self.getEventId();
    self.event_collectionName = self.getEventCollectionName();
    self.userID = self.getSessionUserId();
    self.Currencies = await self.getCurrencies();
  },
  mounted() {
    //alert("mounted")
  },
  methods: {
    changeRegTypesStatus(value, RegistrationTypeId) {
      bus.$emit("toggleLoader", true);
      let key = { RegistrationTypeId: RegistrationTypeId };
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
      };
      let requestData = {
        key: key,
        data: { IsPublished: value },
      };
      axios
        .put(APIs.saveRegistrationType, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0) {
            self.showSnackbar("Data Updated!", "success", "top");
          } else {
            self.showSnackbar("Data not Updated!", "error", "top");
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something Went Wrong!", "error", "top");
        });
    },
    getRegistrationTypes() {
      self.showRegTypeFormPopUp = false;
      bus.$emit("toggleLoader", true);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${self.getSessionToken()}`,
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventid,
          },
          data: {
            filter: [
              {
                key: "RegistrationType",
                operator: "!=",
                value: "null",
              },
            ],
            collection: "RegistrationTicketList/RegistrationTicketTypes",
            dockey: "RegistrationTypeId",
          },
        };
        axios
          .post(APIs.getCollectionDocsAPI, requestData, { headers: headers })
          .then(function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0 && res.data.result.length) {
              self.RegistrationTypeList = res.data.result;
              resolve(res.data.result);
            }
          })
          .catch((err) => {
            bus.$emit("toggleLoader", false);
            reject(err);
          });
      });
    },
    async addRegistrationType() {
      self.configdateTimePickerStart.minDate = new Date();
      self.configdateTimePickerEnd.minDate = new Date();

      bus.$emit("toggleLoader", true);
      self.regTypeFormData = await self.fetchRegistrationType(null).catch();
      self.showRegTypeFormPopUp = true;
      bus.$emit("toggleLoader", false);
    },
    async editRegistrationType(id) {
      bus.$emit("toggleLoader", true);
      self.regTypeFormData = await self.fetchRegistrationType(id).catch();
      self.showRegTypeFormPopUp = true;
      bus.$emit("toggleLoader", false);
    },
    fetchRegistrationType(id) {
      return new Promise((resolve, reject) => {
        let eventEndTimestamp = self.getEventEndDate().seconds * 1000;
        self.configdateTimePickerStart.minDate = new Date();
        self.configdateTimePickerStart.maxDate = new Date(eventEndTimestamp);
        self.configdateTimePickerEnd.minDate = new Date();
        self.configdateTimePickerEnd.maxDate = new Date(eventEndTimestamp);
        if (id === null) {
          resolve({
            RegistrationTypeId: null,
            RegistrationType: null,
            ColorCode: "#000",
            FormType: "Free",
            Currency: null,
            Price: 0.0,
            PriceIncludingTax: true,
            Tax: 0,
            Quantity: 1,
            Expiry: 2,
            MinLimit: 1,
            MaxLimit: 1,
            Description: null,
            SaleStartDate: new Date(),
            SaleEndDate: new Date(self.getCurrentEvent().EventEndTimestamp),
            // SaleEndDate: self.GetTimeByZone(
            //   self.getCurrentEvent().EventEndDateTime,
            //   self.event_timezone
            // ),
            IsPublished: true,
            Visibility: true,
            AdvancedSettings: false,
          });
        } else {
          let headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${self.getSessionToken()}`,
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventid,
          };
          axios
            .get(`${APIs.getRegistrationTypeDetail}?Id=${id}`, {
              headers: headers,
            })
            .then(function (res) {
              if (res.data.status == 0) {
                let data = res.data.result;
                data.RegistrationType = data.RegistrationType
                  ? data.RegistrationType
                  : null;
                data.ColorCode = data.ColorCode ? data.ColorCode : "#000";
                data.FormType = data.FormType ? data.FormType : "Free";
                data.Currency = data.Currency ? data.Currency : null;
                data.Price = data.Price ? Number(data.Price) : 0.0;
                data.PriceIncludingTax = data.PriceIncludingTax
                  ? data.PriceIncludingTax
                  : true;
                data.Tax = data.Tax ? Number(data.Tax) : 0.0;
                data.Quantity = data.Quantity ? Number(data.Quantity) : 1;
                data.Expiry = data.Expiry ? data.Expiry : 2;
                data.MinLimit = data.MinLimit ? Number(data.MinLimit) : 1;
                data.MaxLimit = data.MaxLimit ? Number(data.MaxLimit) : 1;
                data.Description = data.Description ? data.Description : null;
                var SaleStartTimestamp = data.SaleStartDate._seconds * 1000;
                var SaleEndTimestamp = data.SaleEndDate._seconds * 1000;
                data.SaleStartDate = data.SaleStartDate
                  ? new Date(SaleStartTimestamp)
                  : new Date();
                data.SaleEndDate = data.SaleEndDate
                  ? new Date(SaleEndTimestamp)
                  : new Date();
                data.IsPublished = data.IsPublished ? true : false;
                data.Visibility = data.Visibility ? true : false;
                data.AdvancedSettings = data.AdvancedSettings
                  ? data.AdvancedSettings
                  : false;
                if (SaleStartTimestamp < new Date().getTime()) {
                  self.configdateTimePickerStart.minDate = new Date(
                    SaleStartTimestamp
                  );
                }
                if (SaleEndTimestamp < new Date().getTime()) {
                  self.configdateTimePickerEnd.minDate = new Date(
                    SaleEndTimestamp
                  );
                }
                resolve(data);
              }
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    saveRegistrationType() {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
      };
      let requestData = {
        key: {
          RegistrationTypeId: self.regTypeFormData.RegistrationTypeId,
        },
        data: {
          RegistrationType: self.regTypeFormData.RegistrationType,
          ColorCode: self.regTypeFormData.ColorCode,
          FormType: self.regTypeFormData.FormType,
          Currency: self.regTypeFormData.Currency,
          Price: Number(self.regTypeFormData.Price),
          PriceIncludingTax: self.regTypeFormData.PriceIncludingTax,
          Tax: Number(self.regTypeFormData.Tax),
          Quantity: Number(self.regTypeFormData.Quantity),
          Expiry: Number(self.regTypeFormData.Expiry),
          MinLimit: Number(self.regTypeFormData.MinLimit),
          MaxLimit: Number(self.regTypeFormData.MaxLimit),
          Description: self.regTypeFormData.Description,
          SaleStartDate: self.GetTimeByZone(
            self.regTypeFormData.SaleStartDate,
            self.event_timezone
          ),
          SaleEndDate: self.GetTimeByZone(
            self.regTypeFormData.SaleEndDate,
            self.event_timezone
          ),
          IsPublished: self.regTypeFormData.IsPublished,
          Visibility: self.regTypeFormData.Visibility,
          AdvancedSettings: self.regTypeFormData.AdvancedSettings,
        },
      };

      if (self.regTypeFormData.RegistrationTypeId) {
        axios
          .put(APIs.saveRegistrationType, requestData, {
            headers: headers,
          })
          .then(async function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0) {
              self.showSnackbar("Data Updated", "success", "top");
              self.regTypeFormData = await self
                .fetchRegistrationType(null)
                .catch();
              self.getRegistrationTypes();
            } else {
              self.showSnackbar("Data not Updated!", "error", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      } else {
        axios
          .post(APIs.saveRegistrationType, requestData, {
            headers: headers,
          })
          .then(async function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0) {
              self.showSnackbar("Data Added", "success", "top");
              self.regTypeFormData = await self
                .fetchRegistrationType(null)
                .catch();
              self.getRegistrationTypes();
            } else {
              self.showSnackbar("Data not Added!", "error", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      }
    },
    getCurrencies() {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://resources.e2m.live/e2monair.appspot.com/OA_UAT/Defaults/currencies.json"
          )
          .then((res) => {
            if (res.status == 200) resolve(res.data);
            else resolve([]);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
  },
};
</script>